import type { OverviewResponse } from "contracts/api/dashboard/responses";
import { Show } from "solid-js";
import type { PageMapLens } from "../../enums/map";
import type { FlowsView } from "../../enums/scan";
import { FLOWS_VIEW } from "../../enums/scan";
import { estateRouteFocusProps } from "./estateRouteFocus";
import { InteractiveEstateMap } from "./InteractiveEstateMap";
import { JourneySelectedPanel } from "./JourneySelectedPanel";
import type {
  CandidateJourney,
  JourneyPage,
  PriorityContentFlow,
} from "./journeyTypes";
import { SinglePageScanState } from "./SinglePageScanState";

export function FlowsEstatePanel(props: {
  data: OverviewResponse;
  websiteId: string;
  view: FlowsView;
  lens: PageMapLens;
  selectedPage: JourneyPage | null;
  selectedCluster: string | null;
  selectedPath: CandidateJourney | null;
  selectedFlow: PriorityContentFlow | null;
  returnQuery: string;
  onSelectPage: (pageId: string) => void;
  onClearSelection: () => void;
}) {
  return (
    <section class="signal-panel signal-pages-estate-panel">
      <div class="signal-panel-head">
        <div>
          <h2>Page context map</h2>
          <p>
            Page relationships, clusters, areas needing attention and pages
            linked to priority issues from the current inventory.
          </p>
        </div>
      </div>
      <Show
        when={props.data.pages.length > 1}
        fallback={
          <Show
            when={props.data.pages.length === 1}
            fallback={
              <p class="signal-muted">
                No pages are available in the current completed scan inventory.
              </p>
            }
          >
            <SinglePageScanState
              data={props.data}
              websiteId={props.websiteId}
            />
          </Show>
        }
      >
        <div
          class={`flow-map-focus-layout${props.view === FLOWS_VIEW.PATHS ? " is-paths" : ""}`}
        >
          <div class="signal-map-frame signal-pages-map-frame">
            <InteractiveEstateMap
              data={props.data}
              lens={props.lens}
              selectedPageId={props.selectedPage?.id ?? null}
              activeCluster={props.selectedCluster}
              {...estateRouteFocusProps(props.view, props.selectedPath)}
              onSelect={props.onSelectPage}
              onClearSelection={props.onClearSelection}
            />
          </div>
          <Show when={props.view === FLOWS_VIEW.PATHS}>
            <JourneySelectedPanel
              data={props.data}
              websiteId={props.websiteId}
              flow={props.selectedFlow}
              journey={props.selectedPath}
              selectedPage={props.selectedPage}
              returnQuery={props.returnQuery}
            />
          </Show>
        </div>
      </Show>
    </section>
  );
}
